<template>
  <jt-card-default
    :shouldShowSelectMonth="true"
    :cardSelectType="0"
    :shouldShowFullscreen="false"
    @change="onChangeSelectDate"
  >
    <div v-if="isLoading" class="div-loader">
      <div class="spinning-loader rotate"></div>
    </div>

    <br />
    <br />

    <q-markup-table separator="none" class="bg-blue-grey-2">
      <thead>
        <tr>
          <th colspan="3">
            <div class="text-h6">Faturamento</div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th colspan="3">
            <hr />
          </th>
        </tr>
        <tr>
          <th class="text-left"></th>
          <th class="text-center">Mês</th>
          <th class="text-center">Ano</th>
        </tr>
        <tr v-for="item in rowsMonthYear" :key="item">
          <td class="text-right">{{ item.name }}</td>
          <td class="text-center">
            <q-chip
              square
              size="md"
              color="white"
              class="text-center full-width"
            >
              <div class="text-center full-width">{{ item.month }}</div>
            </q-chip>
          </td>
          <td class="text-center">
            <q-chip
              square
              size="md"
              color="white"
              class="text-center full-width"
              ><div class="text-center full-width">
                {{ item.year }}
              </div></q-chip
            >
          </td>
        </tr>
      </tbody>
      </q-markup-table>
      <q-markup-table separator="none" class="bg-blue-grey-2">
      <thead>

      </thead>
      <tbody>
        <tr>
          <th colspan="2">
            <hr />
          </th>
        </tr>
        <tr>
            <th colspan="2">
              <div class="text-h7">{{this.$gettext('DASHBOARD_COMMERCIAL_AVG_PRICE')}}</div>
            </th>
         </tr>
        <tr>
          <td>
            <jt-info-card
              ref="invoicingAvgPublic"
              iconName="people"
              accentColor="green"
              label="DASHBOARD_INVOICING_PUBLIC"
              :shouldTranslateLabel="true"
              :shouldFormatValue="true"
              :infoType="textFormattingType.CURRENCY"
              nmInterface="entrance.hql"
              nmGrid="invoicingAvgPublic"
              nmGridProperty="value"
              :parameters="{ month: monthSelect, year: yearSelect }"
            />
          </td>
          <td>
            <jt-info-card
              ref="invoicingAvgPrivate"
              iconName="people"
              accentColor="blue"
              label="DASHBOARD_INVOICING_PRIVATE"
              :shouldTranslateLabel="true"
              :shouldFormatValue="true"
              :infoType="textFormattingType.CURRENCY"
              nmInterface="entrance.hql"
              nmGrid="invoicingAvgPrivate"
              nmGridProperty="value"
              :parameters="{ month: monthSelect, year: yearSelect }"
            />
          </td>
        </tr>
      </tbody>
    </q-markup-table>
  </jt-card-default>
</template>
<script>
import JtCardDefault from 'src/components/dashboard/dashboard-card-components/base/JtCardDefault.vue'
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import JtInfoCard from 'src/components/dashboard/dashboard-card-components/JtInfoCard.vue'
import { TEXT_FORMATTING_TYPE } from 'src/components/dashboard/shared'
import moment from 'moment'

@Component({
  name: 'InvoiceMonthYear',
  components: {
    JtCardDefault, JtInfoCard
  }
})
export default class InvoiceMonthYear extends Vue {
  textFormattingType = TEXT_FORMATTING_TYPE
  isLoading = false;

  currentDate = {
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    day: new Date().getDate()
  };

  monthSelect;
  yearSelect;

  rowsMonthYear = [];

  setZeros () {
    this.rowsMonthYear = [
      {
        name: this.$gettext('DASHBOARD_INVOICING_AMOUNT'),
        month: '0',
        year: '0'
      },
      {
        name: this.$gettext('DASHBOARD_INVOICING_PROJECTED'),
        month: '0',
        year: '0'
      },
      {
        name: this.$gettext('DASHBOARD_INVOICING_TENDENCY'),
        month: '0',
        year: '0'
      },
      {
        name: this.$gettext('DASHBOARD_INVOICING_VAR_TENDENCY_PROJECTED'),
        month: '0',
        year: '0'
      }
    ]
  }

  created () {
    this.onChangeSelectDate(this.currentDate)
  }

  onChangeSelectDate (date) {
    this.isLoading = true
    this.setDataTable(date)

    this.monthSelect = date.month
    this.yearSelect = date.year

    this.$nextTick(() => {
      this.$refs.invoicingAvgPrivate.reload()
      this.$refs.invoicingAvgPublic.reload()
    })

    setTimeout(() => {
      this.isLoading = false
    }, 500)
  }

  setDataTable (date) {
    this.setZeros()
    this.setProjectedInvoicingMonthYear(date)
    this.setInvoicingMonth(date)
    this.setInvoicingYear(date)
  }

  async setProjectedInvoicingMonthYear (date) {
    const monthValuesProjected = await this.getProjectedMonths(date)
    this.rowsMonthYear[1].month = monthValuesProjected[date.month - 1].toLocaleString('pt-BR')
    this.rowsMonthYear[1].year = monthValuesProjected.reduce((a, b) => a + b).toLocaleString('pt-BR')
  }

  async setInvoicingMonth (date) {
    const { registros } = await repository.resolveDatatableModel(
      'entrance.hql',
      {
        grid: 'invoicingMonth',
        month: date.month,
        year: date.year
      }
    )

    if (registros.length != 0) {
      const data = registros.reduce((register) => register)

      this.rowsMonthYear[0].month =
        Number(data.value.replaceAll('.', '').replace(',', '.')).toLocaleString('pt-BR')

      this.setOthersValuesInMonths(date)
    }
  }

  async setInvoicingYear (date) {
    const { registros } = await repository.resolveDatatableModel(
      'entrance.hql',
      {
        grid: 'invoicingYear',
        year: date.year
      }
    )

    if (registros.length != 0) {
      const data = registros.reduce((register) => register)

      this.rowsMonthYear[0].year =
        Number(data.value.replaceAll('.', '').replace(',', '.')).toLocaleString('pt-BR')

      this.setOthersValuesInYears(date)
    }
  }

  setOthersValuesInMonths (date) {
    const amountMonth = Number(this.rowsMonthYear[0].month.replaceAll('.', '').replace(',', '.'))
    let tendencyMonth = amountMonth
    if ((moment().month() == (date.month - 1)) && (moment().year() == date.year)) {
      const dayOfMonth = moment().date()
      tendencyMonth = (amountMonth * moment().daysInMonth()) / dayOfMonth
    }
    this.rowsMonthYear[2].month = tendencyMonth.toLocaleString('pt-BR')
    if (this.rowsMonthYear[1].month != 0) {
      const varTendencyProjected = ((tendencyMonth / Number(this.rowsMonthYear[1].month.replaceAll('.', '').replace(',', '.'))) - 1) * 100
      this.rowsMonthYear[3].month = varTendencyProjected.toLocaleString('pt-BR') + '%'
    }
  }

  setOthersValuesInYears (date) {
    const amountYear = Number(this.rowsMonthYear[0].year.replaceAll('.', '').replace(',', '.'))
    let tendencyYear = amountYear
    if (moment().year() == date.year) {
      const dayOfYear = moment().dayOfYear()
      tendencyYear = (amountYear * 365) / dayOfYear
    }
    this.rowsMonthYear[2].year = tendencyYear.toLocaleString('pt-BR')
    if (this.rowsMonthYear[1].year != 0) {
      const varTendencyProjected = ((tendencyYear / Number(this.rowsMonthYear[1].year.replaceAll('.', '').replace(',', '.'))) - 1) * 100
      this.rowsMonthYear[3].year = varTendencyProjected.toLocaleString('pt-BR') + '%'
    }
  }

  async getProjectedMonths (date) {
    const monthValuesProjected = Array.from({ length: 12 }, (item, index) => 0)

    const { registros } = await repository.resolveDatatableModel(
      'projectedMonth.pesquisar',
      {
        grid: 'pesquisa',
        projectedMonthType: 20450002,
        year: date.year
      }
    )
    if (registros.length != 0) {
      const projectedMonth = registros[0]
      monthValuesProjected[0] = (projectedMonth.jan ? projectedMonth.jan : '0')
      monthValuesProjected[1] = (projectedMonth.feb ? projectedMonth.feb : '0')
      monthValuesProjected[2] = (projectedMonth.mar ? projectedMonth.mar : '0')
      monthValuesProjected[3] = (projectedMonth.apr ? projectedMonth.apr : '0')
      monthValuesProjected[4] = (projectedMonth.may ? projectedMonth.may : '0')
      monthValuesProjected[5] = (projectedMonth.jun ? projectedMonth.jun : '0')
      monthValuesProjected[6] = (projectedMonth.jul ? projectedMonth.jul : '0')
      monthValuesProjected[7] = (projectedMonth.aug ? projectedMonth.aug : '0')
      monthValuesProjected[8] = (projectedMonth.sep ? projectedMonth.sep : '0')
      monthValuesProjected[9] = (projectedMonth.oct ? projectedMonth.oct : '0')
      monthValuesProjected[10] = (projectedMonth.nov ? projectedMonth.nov : '0')
      monthValuesProjected[11] = (projectedMonth.dec ? projectedMonth.dec : '0')

      monthValuesProjected.forEach((register, index) => {
        monthValuesProjected[index] = Number(parseFloat(register.replaceAll('.', '').replaceAll(',', '.')))
      })
    }
    return monthValuesProjected
  }
}
</script>

<style lang='stylus' scoped>
@import '~quasar-variables';

.q-chip {
  max-width: 180px;
}
</style>
